import React, { useMemo, useState } from 'react'
import Card from 'components/common/Card';
import Heading from 'components/common/Heading';
import Image from 'components/common/Image';
import pickRandomFromArray from 'utils/pickRandomFromArray';
import BookHoverHandler from './BookHoverHandler';
import BookMoreinfoModal from './BookMoreInfoModal';
import RoundedCover from './BookCover/RoundedCover';
import BookAuthorsList from './BookAuthorsList';
import getBookCoverUrl from 'utils/bookCoverUrl';

import { GiBookshelf, GiBookAura, GiBookPile, GiBookStorm, GiBookmarklet, GiEvilBook, GiSpellBook } from 'react-icons/gi'

const bookIcons = [
    <GiBookshelf />,
    <GiBookAura />,
    <GiBookPile />,
    <GiBookStorm />,
    <GiBookmarklet />,
    <GiEvilBook />,
    <GiSpellBook />,
]

const BookCard = ({ data, roundedCover, ...rest }) => {
    const { 
        title, 
        authors = [], 
        covers = [], 
        publish_date, 
        cover_i,
        isbn = [],
        isbn_13
    } = data;

    const [showModal, setShowModal] = useState(false);

    const coverUrl = getBookCoverUrl(covers[0] ?? cover_i);

    const placeholder = useMemo(() => pickRandomFromArray(bookIcons), []);

    const isbnCode = isbn.length > 0 ? isbn[0] : isbn_13;

    return (
        <Card fluid {...rest}>
            <div className="p-6 group relative">
                {
                    roundedCover ? (
                        <RoundedCover src={coverUrl} placeholder={placeholder} />
                    ) : (
                        <div className="flex justify-center mb-4 h-96">
                            <Image src={coverUrl} className="object-contain" alt="" placeholder={placeholder} />
                        </div>
                    )
                }

                <Heading as="h3">
                    { title }
                </Heading>

                <p>
                    { publish_date }
                </p>

                <BookAuthorsList authors={authors} />

                {/* Hover handler */}
                { isbnCode && <BookHoverHandler setShowModal={setShowModal} showModal={showModal} />}

                {/* Modal with more info */}
                { showModal && <BookMoreinfoModal setShowModal={setShowModal} isbn={isbnCode} />}
            </div>
        </Card>
    )
}

export default BookCard